{
  "nav": {
    "home": "Home",
    "services": "Services",
    "prices": "Prices",
    "projects": "Projects",
    "about": "About",
    "contact": "Contact",
    "email": "Email",
    "linkedin": "LinkedIn"
  },
  "backToProjects": "Back to projects",
  "projectOverview": "Project Overview",
  "overview": "Overview",
  "challenge": "The Challenge",
  "businessNeed": "The Business Need",
  "philosophy": "The Philosophy",
  "goal": "The Goal",
  "solution": "The Solution",
  "polestarLandingPage": "Polestar Live Landing page"
}
